import Cookies from "js-cookie";

const CookieKeys = {
  //滑动验证信息
  accessCaptchaPermission: "accessCaptchaPermission",
  //用户名
  qlm_username: "qlm_username",
  //用户密码
  qlm_password: "qlm_password",

  //用户信息
  userInfo: "userInfo",
  //Token信息
  xAuthToken: "xAuthToken",
  //wap-Token信息
  authToken: "authToken",
  userAppMenu: "userAppMenu",
  userLeftMenuClick: "userLeftMenuClick",
  qlmVisitorId: "qlm_visitor_id",
};

export { CookieKeys, Cookies };
